module.exports = __webpack_public_path__ + "50ca6db42832a98afa705cffb46186df.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/fr.json
// module id = 1157
// module chunks = 0